import { BLOCKS } from '@contentful/rich-text-types'
import { getConfig } from '../../../config'
import { HOMEPAGE_SLUG } from '../../constants'
import { ComponentCtaButtonColor, ComponentCtaButtonType } from '../../types'
import { ComponentContentTypes } from '../../types/content-types'
import { createEntry } from '../../utils/contentful-entry'
import { PatchPageStructure } from '../types'

const config = getConfig()

// #ToDo improve typings to avoid namespace usage. Replace with the named export and import * as BrowserPagesSignUpFlowExperiment ... usage
// eslint-disable-next-line @typescript-eslint/no-namespace
export namespace HomepageMobileExperiment {
  const signupFlowLinkEntry = createEntry(ComponentContentTypes.ComponentLink, 'HomepageSignupFlowLink', {
    targetUrl: `${config.urls.main}/signup`,
    targetTab: 'New ( _blank )',
    internalName: `${config.urls.main}/signup`,
    appendCurrentQueryParams: true,
  })

  const newCtaEntry = createEntry(ComponentContentTypes.ComponentCtaButton, 'ExperimentalSignupFlowCta', {
    ctaText: {
      data: {},
      content: [
        {
          data: {},
          content: [
            {
              data: {},
              marks: [
                {
                  type: 'bold',
                },
              ],
              value: 'Get Grammarly',
              nodeType: 'text',
            },
            {
              data: {},
              marks: [],
              value: '  It’s free',
              nodeType: 'text',
            },
          ],
          nodeType: BLOCKS.PARAGRAPH,
        },
      ],
      nodeType: BLOCKS.DOCUMENT,
    },
    internalName: 'SignupFlowExperimentalCta',
    color: ComponentCtaButtonColor.WhiteTextGreenButton,
    type: ComponentCtaButtonType.Link,
    targetLink: signupFlowLinkEntry,
  })

  export const patchPageStructure: PatchPageStructure = (
    pageStructure,
    _experimentService,
    userService,
    browserService,
    facadeService
  ) => {
    const { isAnonymous } = userService.currentUser
    const { isMobile } = browserService
    const pageSlug = facadeService.get().pageSlug
    if (pageSlug === HOMEPAGE_SLUG && isAnonymous && isMobile) {
      const patchedHeaderCtas = pageStructure.fields?.header?.fields?.stickyCtas?.map(() => newCtaEntry)

      return {
        ...pageStructure,
        fields: {
          ...pageStructure.fields,
          header: {
            ...(pageStructure.fields?.header || {}),
            fields: {
              ...(pageStructure.fields?.header?.fields || {}),
              stickyCtas: patchedHeaderCtas,
            },
          },
        },
      }
    }
    return pageStructure
  }
}
